import React from "react"
import { List, Typography, Space } from "antd"
import { css } from "@emotion/react"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { Asset, Entry } from "contentful"
import { TypeTextBlockSkeleton } from "../../lib/contentful/ContentfulVzdelanibudoucnostiTypes"
import Image from "next/image"
import { documentToRenderOptions } from "../Layout/documentToRenderOptions"

interface TechnologyTextBlocksProps {
  textBlocks: Entry<TypeTextBlockSkeleton, undefined, string>[]
}

export const TechnologyTextBlocks: React.FC<TechnologyTextBlocksProps> = ({ textBlocks }) => {
  return (
    <Space direction="vertical" style={{ display: "initial" }}>
      {textBlocks?.map((block: Entry<TypeTextBlockSkeleton, undefined, string>) => {
        const hasTitle = block.fields.title && block.fields.title.length > 0
        const hasContent = block.fields.content
        const hasImage = block.fields.image && block.fields.image.length > 0

        if (!hasTitle && !hasContent && !hasImage) {
          return null
        }

        return (
          <div
            key={block.sys.id}
            css={css`
              margin-bottom: 20px;

              .ant-list-sm .ant-list-item {
                padding: 8px 0;
              }
            `}>
            {hasTitle && <Typography.Title level={4}>{block.fields.title}</Typography.Title>}

            {hasContent && (
              <List
                size="small"
                css={css`
                  padding: 14px;
                  background-color: #fff;
                  border-radius: 20px;

                  .ant-typography {
                    &:last-of-type {
                      margin-bottom: 0;
                    }
                  }

                  .ant-spin-container {
                    .ant-typography {
                      &:last-of-type {
                        margin-bottom: 0;
                      }
                    }
                  }

                  .ant-list-item {
                    &:first-of-type {
                      padding-top: 0;
                    }

                    &:last-of-type {
                      padding-bottom: 0;

                      .ant-typography {
                        &:last-of-type {
                          margin-bottom: 0;
                        }
                      }
                    }
                  }
                `}>
                {documentToReactComponents(block.fields.content, documentToRenderOptions)}
              </List>
            )}

            {hasImage &&
              block.fields.image.map((imageAsset: Asset<undefined, string>) => (
                <div
                  key={imageAsset.sys.id}
                  css={css`
                    position: relative;
                    width: 100%;
                    height: 0;
                    padding-bottom: ${imageAsset.fields.file?.details.image
                      ? `${(imageAsset.fields.file.details.image.height / imageAsset.fields.file.details.image.width) * 100}%`
                      : "56.25%"};
                    border-radius: 20px;
                    overflow: hidden;
                    margin-top: ${hasTitle || hasContent ? "10px" : "0"};
                  `}>
                  <Image
                    src={`https:${imageAsset.fields.file?.url}`}
                    alt={imageAsset.fields.title || "Block Image"}
                    fill
                    sizes="(max-width: 768px) 100vw, 50vw"
                    style={{ objectFit: "contain" }}
                  />
                </div>
              ))}
          </div>
        )
      })}
    </Space>
  )
}
